<template>
    <div class="notice">
      <div>
        <!-- <span class="back" @click="routerTo('/pcpage/noticelist/notice_ul')">
          <img src="../img/arrow.png" alt=""> 赛事公告
        </span> -->
      </div>
      <div class="content">
        <div class="title">
          评奖方式及规则
        </div>
        <h2>1．评奖办法：</h2>
        <p>
          （1）所有参赛作品经审核后发布在<strong>“2021年志愿者短视频与图片故事征集活动”</strong>专题网页进行展示，参赛者及网络注册用户可登录大赛页面后进行在线助推或投票，
          助推时间为2021年9月15日（待定）至2022年5月30日在专题上传阶段进行（助推的优秀作品，将通过“国际中文教师志愿者俱乐部”公众号，以文章的形式进行展示和推荐） 投票时间将在征集上传工作结束后，
          于2022年6月1日至2022年6月30日进行，投票结果将最终产生“最佳人气奖”。
        </p>
        <p>
          （2）每个ID对每个作品每天限助推或投票1次。如发现利用网络工具刷票现象，将取消该作品的得票数，情节严重者将取消该作者的参赛资格;
        </p>
        <p>
          （3）组织专家评审团，根据照片故事性、技术指标等各项信息，进行为期三轮的评选，并参考得票情况，评选出获奖作品；
        </p>
        <p>
          （4）每位参赛者最多只能有一个作品（故事图组或视频）获得某一类别奖项；
        </p>
        <p>
          （5）所有获奖作品及优秀奖作品及奖品信息将在“2021年志愿者短视频与图片故事征集活动”专题网页公布。公布展示时间为2022年8月1日至2022年8月30日。
        </p>
        <p>
          （6）相关奖项内容、获奖人数:
        </p>
        <p class="p_left">
          一等奖：3人，其中视频类：2人、图片类：1人
        </p>
        <p class="p_left">二等奖：10人，其中视频类：6人、图片类：4人</p>
        <p class="p_left">三等奖：20人，其中视频类：15人、图片类：5人</p>
        <p class="p_left">优秀奖：40人，其中视频类：30人、图片类：10人</p>
        <p class="p_left">最佳人气奖：2人，其中视频类：1人、图片类：1人</p>
        <p class="p_left">参与奖：所有参与投稿的志愿者，均可获得参与奖相关证书。</p>
      </div>
    </div>
</template>

<script>
export default {
    name: 'notice',
    data: function () {
        return {
            
        }
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
    width: 1200px;
    margin: 80px auto 50px;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .back {
      font-size: 24px;
      color: #0b0b0b;
      font-weight: bold;
      cursor: pointer;
      img {
        vertical-align: middle;
        margin-top: -4px;
      }
    }
    .content {
      width: 1200px;
      background-color: #fff;
      padding: 0 40px 70px;
      text-align: center;
      margin-top: 40px;
      box-sizing: border-box;
      .title {
        position: relative;
        top: -35px;
        width: 405px;
        height: 70px;
        line-height: 65px;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 35px;
        text-align: center;
        font-size: 50px;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -60px;
          top: 15px;
          content: '';
          display: inline-block;
          width: 60px;
          height: 60px;
          background-image: url(../img/left.png);
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -80px;
          top: 15px;
          content: '';
          display: inline-block;
          width: 60px;
          height: 60px;
          background-image: url(../img/right.png);
          background-repeat: no-repeat;
        }
      }
      p {
        text-align: left;
        font-size: 24px;
        color: #0b2ab0;
        line-height: 1.6;
        strong {
          font-weight: bold;
        }
      }
      .p_left {
        text-indent: 2.5em;
      }
      h2 {
        font-size: 28px;
        font-weight: bold;
        color: #0b2ab0;
        text-align: left;
        margin-top: 25px;
        margin-bottom: 20px;
      }
      h3 {
        font-size: 28px;
        color: #0b2ab0;
        text-align: left;
        margin-top: 20px;
        text-indent: 1em;
      }
    }
}
</style>
